import { useExternalAccessRights, useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';
import { checkRole } from 'common/wolt-permissions/permissionUtils';

export const useIsBrandSharedMenuEnabled = (brandId: string, enabled = true) => {
  const { isEmployee } = useUser();
  const externalAccessRights = useExternalAccessRights();

  const hasExternalRolePermission = checkRole(externalAccessRights, 'brand', brandId, roles =>
    roles.some(role => role === 'brand_owner'),
  );

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(
    ['enable_shared_menu_for_merchant_or_brand'],
    {
      brand_id: brandId,
    },
    { enabled: enabled && !isEmployee && hasExternalRolePermission },
  );

  if (isEmployee) {
    return true;
  }

  if (!hasExternalRolePermission || (isLoading && isFetching)) {
    return false;
  }

  return featureFlags?.enable_shared_menu_for_merchant_or_brand === 'enabled_for_brand';
};

export const useIsMerchantSharedMenuEnabled = (merchantId: string, enabled = true) => {
  const { isEmployee } = useUser();
  const externalAccessRights = useExternalAccessRights();

  const hasExternalRolePermission = checkRole(externalAccessRights, 'merchant', merchantId, roles =>
    roles.some(role => role === 'merchant_owner'),
  );

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(
    ['enable_shared_menu_for_merchant_or_brand'],
    {
      merchant_id: merchantId,
    },
    { enabled: enabled && !isEmployee && hasExternalRolePermission },
  );

  if (isEmployee) {
    return true;
  }

  if (!hasExternalRolePermission || (isLoading && isFetching)) {
    return false;
  }

  return featureFlags?.enable_shared_menu_for_merchant_or_brand === 'enabled_for_merchant';
};
